import { Record } from "immutable";

const defaults = {
    brand_name: undefined,
    contact_information: {},
    images: [],
    logo: undefined,
    modules: {},
    name: undefined,
    _id: undefined,
};

class BrandedLoginRecord extends Record(defaults) {
    declare contact_information: any;
    declare modules: any;

    get contactEmails() {
        return this.contact_information.emails || [];
    }

    get salesReps() {
        return this.modules.buyer_marketplace.sales_reps || [];
    }

    get hasMarketplaceReps() {
        return this.modules.buyer_marketplace.sales_reps.length;
    }
}

export { BrandedLoginRecord };
